import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useState, createContext, useContext } from 'react';
import axios from 'axios';
export var TeamContext = /*#__PURE__*/ createContext({
    reviewTeamTree: [],
    setReviewTeamTree: function setReviewTeamTree() {},
    selectedUser: null,
    setSelectedUser: function setSelectedUser() {},
    selectedUserList: [],
    setSelectedUserList: function setSelectedUserList() {},
    clearState: function clearState() {},
    loading: false,
    fetchTeamMembers: function fetchTeamMembers() {
        return _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2
                ];
            });
        })();
    },
    buildReviewTeamTree: function buildReviewTeamTree() {
        return [];
    },
    selectedBreadcrumbUser: null,
    setSelectedBreadcrumbUser: function setSelectedBreadcrumbUser() {}
});
var TeamContextProvider = function TeamContextProvider(props) {
    var _useState = _sliced_to_array(useState([]), 2), reviewTeamTree = _useState[0], setReviewTeamTree = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), selectedUser = _useState1[0], setSelectedUser = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), selectedUserList = _useState2[0], setSelectedUserList = _useState2[1];
    var _useState3 = _sliced_to_array(useState(null), 2), selectedBreadcrumbUser = _useState3[0], setSelectedBreadcrumbUser = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), loading = _useState4[0], setLoading = _useState4[1];
    var fetchTeamMembers = function fetchTeamMembers(oid, myOid) {
        return _async_to_generator(function() {
            var response, teamList, teamTree, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4,
                            axios.get("/api/common/getTeamMembers?oid=".concat(oid))
                        ];
                    case 1:
                        response = _state.sent();
                        teamList = response.data.directReports;
                        teamTree = buildReviewTeamTree(teamList, oid, myOid);
                        setReviewTeamTree(teamTree);
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        console.error('Error fetching team members:', error);
                        if (error.response) {
                            console.error('Error response data:', error.response.data);
                            console.error('Error response status:', error.response.status);
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var buildReviewTeamTree = function buildReviewTeamTree(teamList, oid, myOid) {
        // Helper function to find a node in the tree by oid
        var findNodeByOid = function findNodeByOid1(tree, targetOid) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var node = _step.value;
                    if (node.oid === targetOid) {
                        return node;
                    }
                    if (node.children && node.children.length > 0) {
                        var found = findNodeByOid(node.children, targetOid);
                        if (found) return found;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return null;
        };
        // Filter out myOid and sort by directReportsCount
        var processTeamList = function processTeamList(list) {
            return list.filter(function(member) {
                return member.oid !== myOid;
            }).sort(function(a, b) {
                return b.directReportsCount - a.directReportsCount;
            }).map(function(member) {
                return _object_spread_props(_object_spread({}, member), {
                    children: [],
                    hasChildren: member.directReportsCount > 0,
                    isExpanded: false
                });
            });
        };
        // If this is the root level (initial load)
        if (!reviewTeamTree.length) {
            return processTeamList(teamList);
        }
        var parentNode = findNodeByOid(reviewTeamTree, oid);
        if (parentNode) {
            // Check if we already have children for this node
            if (parentNode.children.length > 0) {
                return reviewTeamTree // Don't update if we already have children
                ;
            }
            // Update the parent node's children
            parentNode.children = processTeamList(teamList);
            parentNode.isExpanded = true;
        }
        return reviewTeamTree;
    };
    var clearState = function clearState() {
        setReviewTeamTree([]);
        setSelectedUser(null);
        setSelectedUserList([]);
    };
    return /*#__PURE__*/ _jsx(TeamContext.Provider, {
        value: {
            reviewTeamTree: reviewTeamTree,
            setReviewTeamTree: setReviewTeamTree,
            selectedUser: selectedUser,
            setSelectedUser: setSelectedUser,
            selectedUserList: selectedUserList,
            setSelectedUserList: setSelectedUserList,
            clearState: clearState,
            loading: loading,
            fetchTeamMembers: fetchTeamMembers,
            buildReviewTeamTree: buildReviewTeamTree,
            selectedBreadcrumbUser: selectedBreadcrumbUser,
            setSelectedBreadcrumbUser: setSelectedBreadcrumbUser
        },
        children: props.children
    });
};
var useTeamContext = function useTeamContext() {
    return useContext(TeamContext);
};
export { TeamContextProvider, useTeamContext };
